<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

@if (organizationData$ | async; as organizationData) {
  <ptl-v3-auth-layout [organizationData]="organizationData" [showMaintenanceOverlay]="showMaintenanceOverlay">
    <div class="v3-headline">
      <h1 class="v3-title">{{ organizationData.name }}</h1>
      <p class="v3-subtitle fs-body-m">{{ organizationData.landingPage.welcomeMessage }}</p>
    </div>

    <re-captcha #captchaElem [siteKey]="reCaptchaSiteKeyV2" (resolved)="proceedJoin($event)" size="invisible"></re-captcha>

    <div class="v3-actions">
      <ptl-sg-button type="flat" color="primary" class="v3-submit" [disabled]="!joinReady" (clicked)="onJoinButtonClick()">
        <span>{{ 'translations.public.button.join' | transloco }} {{ organizationData.name }}</span>
      </ptl-sg-button>
    </div>
  </ptl-v3-auth-layout>
} @else {
  <ptl-v3-auth-loading></ptl-v3-auth-loading>
}
